import React, { useContext, useState } from 'react';
import classes from './SideBar.module.css';

import wardPaginationIcon from '../../../images/ward_paginator_icon.png';
import { MainContext } from '../../..';
// import { CSSTransition, TransitionGroup } from "react-transition-group";

const WardPaginator = ({ currentWard, setCurrentWard }) => {
    const { medicalStore } = useContext(MainContext);

    const [isVisible, setIsVisible] = useState(false);
    let wards = [];

    for (let i = 1; i <= Math.ceil(medicalStore.therapies.length / 6); i += 1) {
        wards.push(i);
    }

    return (
        <div>
            <div onClick={() => setIsVisible(!isVisible)} className={classes.wardPaginator}>
                <div style={{ fontSize: '24px' }}>Палата {currentWard}</div>
                <div>
                    <img src={wardPaginationIcon} />
                </div>
            </div>

            {isVisible && (
                <div>
                    {wards.map((ward) => (
                        <span
                            onClick={() => setCurrentWard(ward)}
                            key={ward}
                            className={
                                ward === currentWard ? classes.currentWard : classes.wardPagination
                            }
                        >
                            Палата {ward}
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};

export default WardPaginator;

